import { DistributionDataType } from './map-attribute';


export const distributionDataTypeToString = (value: number | undefined | null, dataType: DistributionDataType) => {
  if (value === undefined || value === null) return '';
  if (dataType === 'percentage')
    return `${value.toFixed(2)}%`;
  if (dataType === 'money')
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: value < 100 ? 2 : 0,
      maximumFractionDigits: value < 100 ? 2 : 0
    });
  if (dataType === 'number' || dataType === 'days')
    return `${value.toFixed(0)}`;
  return value.toString();
};

export const distributionDataTypeToUnit = (dataType: DistributionDataType) => {
  if (dataType === 'percentage')
    return '%';
  if (dataType === 'money')
    return '$';
  if (dataType === 'number' || dataType === 'days')
    return '';
  return '';
};
